module.exports = __webpack_public_path__ + "static/media/arrow-left-rsm.514b7035.svg";